import { delay } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TagUpdateService {

  constructor(private httpClient: HttpClient) {
  }

  updateTag(tag, id,color) {
    return this.httpClient.put(
      `${environment.API_ENDPOINT}tags/${id}`,
      JSON.stringify(tag),
      {
        params:{
          color:color
        }
      }
      )
      .pipe(delay(environment.RESPONSE_DELAY));
  }
}
